function ChevronLeftIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.6131 8.94664C19.0931 8.42664 18.2531 8.42664 17.7331 8.94664L11.6131 15.0666C11.0931 15.5866 11.0931 16.4266 11.6131 16.9466L17.7331 23.0666C18.2531 23.5866 19.0931 23.5866 19.6131 23.0666C20.1331 22.5466 20.1331 21.7066 19.6131 21.1866L14.4398 16L19.6131 10.8266C20.1331 10.3066 20.1198 9.45331 19.6131 8.94664Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ChevronLeftIcon;
